class ProfetNavigation {
	constructor() {
		this.mobileMenuToggle = document.querySelector('.toggle-mobile-menu');
		this.mobileMenuNavigation = document.querySelector('.header-mobile-nav-menu');
		this.mobileMenuNavigationItems = document.querySelectorAll('.header-mobile-nav-menu li a');
		this.mobileMenuVisible = false;
		this.headerDesktop = document.querySelector('#site-header-desktop');
		this.headerDesktopHeight = 0;
		this.headerMobile = document.querySelector('#site-header-mobile');
		this.dropdownArrows = [];
		this.variables = {
			scrollPosition: 0,
		};
		this.scrollLockPosition = 0; // This is the position the user was on when they were scroll locked. We want to be able to set them back to this position when we exit the scroll lock.
	}
	init() {
		if (!this.headerDesktop) {
			return;
		}

		this.closeDesktopSubmenusOnBodyClick();
		this.handleToggleDesktopMenuSubmenus();
		this.handleToggleMobileMenuSubmenus();
		this.handleHeroHeaderNavigation();
		this.handleHeroHeaderNavigationSticky();

		window.addEventListener('scroll', () => {
			this.handleScroll();
		});
		this.handleScroll();

		if (this.mobileMenuToggle) {
			this.mobileMenuToggle.addEventListener('click', (event) => {
				event.preventDefault();
				if (!this.mobileMenuVisible) {
					this.openMobileNavigation();
				} else {
					this.closeMobileNavigation();
				}
			});
		}

		if (this.headerDesktop) {
			this.headerDesktopHeight = this.headerDesktop.offsetHeight;
		}
	}

	handleScroll() {
		this.variables.scrollPosition = window.scrollY;
		this.variables.scrollPosition = window.scrollY;
		if (this.headerDesktop) {
			if (this.variables.scrollPosition > 100) {
				this.headerDesktop.classList.add('scrolled');
				document.querySelector('body').classList.add('scrolled');
			} else {
				this.headerDesktop.classList.remove('scrolled');
				document.querySelector('body').classList.remove('scrolled');
			}
		}
		if (this.headerMobile) {
			if (this.variables.scrollPosition > 60) {
				this.headerMobile.classList.add('scrolled');
				document.querySelector('body').classList.add('scrolled-mobile');
			} else {
				this.headerMobile.classList.remove('scrolled');
				document.querySelector('body').classList.remove('scrolled-mobile');
			}
		}
	}

	handleToggleMobileMenuSubmenus() {
		/* Handle toggling of submenus in the mobile menu */
		let linksWithSubmenus = document.querySelectorAll('#site-navigation-mobile li.menu-item-has-children > a');
		if (linksWithSubmenus) {
			linksWithSubmenus.forEach((link) => {
				link.addEventListener('click', function(event) {
					if (link.getAttribute('href') != '#') {
						return;
					}
					event.preventDefault();
					let parent = link.parentElement;
					parent.classList.toggle('active');
				});
			});
		}
	}

	handleToggleDesktopMenuSubmenus() {
		/* Handle toggling of submenus in the desktop menu */
		let linksWithSubmenus = document.querySelectorAll('#site-header-desktop li.menu-item-has-children > a');
		if (linksWithSubmenus) {
			linksWithSubmenus.forEach((link) => {
				link.addEventListener('click', function(event) {
					if (link.getAttribute('href') != '#') {
						return;
					}
					event.preventDefault();
					let parent = link.parentElement;
					let shouldDisplayDropdown = false;
					if (!parent.classList.contains('active')) {
						shouldDisplayDropdown = true;
					}
					/* Close all other dropdowns */
					linksWithSubmenus.forEach((l) => {
						l.parentElement.classList.remove('active');
					});
					if (shouldDisplayDropdown) {
						parent.classList.add('active');
					}
				});
			});
		}
	}

	closeDesktopSubmenusOnBodyClick() {
		/* Close all submenus when .site-main is clicked, i.e. the user clicks somewhere on the page. */
		let main = document.querySelector('.site-main');
		if (main) {
			main.addEventListener('click', (event) => {
				let linksWithSubmenus = document.querySelectorAll('#site-header-desktop li.menu-item-has-children > a');
				if (linksWithSubmenus) {
					linksWithSubmenus.forEach((l) => {
						l.parentElement.classList.remove('active');
					});
				}
			});
		}
	}

	openMobileNavigation() {
		this.mobileMenuVisible = true;
		this.handleScrollLock();
		document.querySelector('body').classList.add('mobile-menu-open');
	}
	closeMobileNavigation() {
		this.mobileMenuVisible = false;
		this.handleScrollLock(true);
		document.querySelector('body').classList.remove('mobile-menu-open');
	}

	/* Handle navigating the user when they select a page in the hero header navigation dropdown element */
	handleHeroHeaderNavigation() {
		const select = document.querySelector('.hero-header-navigation-mobile-select');
		if (!select) {
			return;
		}
		select.addEventListener('change', function(event) {
			let value = select.value;
			if (value && value != 'placeholder' && value != '#') {
				window.location.href = value;
			}
		});
	}

	/* Make the HeroHeaderNavigation element sticky (on desktop) when the user has scrolled to it */
	handleHeroHeaderNavigationSticky() {
		let element = document.querySelector('.hero-header-navigation');
		if (!element) {
			return;
		}
		let paddingElement = document.querySelector('.hero-header-navigation-padding');
		let rect = element.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let offset = { top: rect.top + scrollTop, left: rect.left + scrollLeft };
        
        let stickyFunc = () => {
			if (this.variables.scrollPosition + this.headerDesktopHeight > offset.top) {
				element.classList.add('sticky');
				paddingElement.style.paddingTop = element.offsetHeight + 'px';
			} else {
				element.classList.remove('sticky');
				paddingElement.style.paddingTop = '0px';
			}
        };


        jQuery(document).ready(stickyFunc);

		window.addEventListener('scroll', stickyFunc);
	}

	handleScrollLock(forceRemoveScrollLock) {
		if (document.querySelector('body').classList.contains('scroll-locked') || forceRemoveScrollLock) {
			document.querySelector('body').classList.remove('scroll-locked');
			window.scrollTo(0, this.scrollLockPosition); // values are x,y-offset
		} else {
			this.scrollLockPosition =
				window.pageYOffset !== undefined
					? window.pageYOffset
					: (document.documentElement || document.body.parentNode || document.body).scrollTop;
			window.setTimeout(function() {
				document.querySelector('body').classList.add('scroll-locked');
			}, 500);
		}
	}
}
window.addEventListener('load', () => {
	window.ProfetNavigation = new ProfetNavigation();
	window.ProfetNavigation.init();
});
